/// <reference path="../../../../../node_modules/react-datetime/react-datetime.d.ts" />

import * as React from 'react';
import DateTime from 'react-datetime';
import { Translate } from '../../../../shared/LanguageService';
import {
    Modal,
    Button,
    ButtonGroup,
    FormGroup,
    FormControl,
    ControlLabel,
    Row,
    Col
} from 'react-bootstrap';
import { assign } from '../../../../shared/Assign';
import { IPhotographerInvoice } from './SinglePhotographerInvoiceTypes';
import ValidatableFormGroup from '../../../../components/common/ValidatableFormGroup';

interface IProps {
    closeModal: () => void;
    allowSaving: boolean;
    allowRejecting: boolean;
    showRejectMessage: boolean;
    html: string;
    errors: any;
    invoiceNumber: string;
    onInvoiceNumberChange: (e: any) => void;
    rejectMessage: string;
    onRejectMessageChange: (e: any) => void;
    instructions: string;
    working: boolean;
    invoice: IPhotographerInvoice;
    reject: (rejectedInvoice: IPhotographerInvoice) => void;
    update: (rejectedInvoice: IPhotographerInvoice) => void;
    save: () => void;
}

const ViewPhotographerInvoiceModal = (props: IProps) => {
    return (
        <div>
            {!props.allowSaving && !props.allowRejecting && !props.showRejectMessage && (
                <Modal show={true} onHide={props.closeModal} bsSize="large">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {Translate('photographer-invoice/modal/view/title')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="invoice-modal-row">
                            <Col xs={12} lg={12} className="invoice-preview-column">
                                {props.html && (
                                    <div
                                        id="invoice-preview"
                                        dangerouslySetInnerHTML={{
                                            __html: props.html
                                        }}
                                    ></div>
                                )}
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={props.closeModal} bsStyle="default">
                            {Translate('photographer-invoice/modal/view/close')}
                        </Button>
                        <Button onClick={() => window.print()} bsStyle="primary">
                            {Translate('photographer-invoice/modal/view/print')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

            {props.allowSaving && props.allowRejecting && (
                <Modal show={true} onHide={props.closeModal} bsSize="large">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {Translate('photographer-invoice/modal/create/title')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="invoice-modal-row">
                            <Col xs={12} lg={7} className="invoice-preview-column">
                                {props.html && (
                                    <div
                                        id="invoice-preview"
                                        dangerouslySetInnerHTML={{
                                            __html: props.html
                                        }}
                                    ></div>
                                )}
                            </Col>
                            <Col xs={12} lg={5} className="hide-print invoice-modifier-column">
                                <ValidatableFormGroup
                                    required={true}
                                    validationKey="invoiceNumber"
                                    errors={props.errors}
                                >
                                    <ControlLabel>
                                        {Translate(
                                            'photographer-invoice/modal/create/invoice-number'
                                        )}
                                    </ControlLabel>
                                    <FormControl
                                        autoFocus
                                        type="text"
                                        name="invoiceNumber"
                                        value={props.invoiceNumber}
                                        onChange={props.onInvoiceNumberChange}
                                    />
                                </ValidatableFormGroup>

                                <FormGroup>
                                    <ControlLabel>
                                        {Translate(
                                            'photographer-invoice/modal/create/reject-message'
                                        )}
                                    </ControlLabel>
                                    <FormControl
                                        required
                                        componentClass="textarea"
                                        name="rejectMessage"
                                        className="text-area-roomy"
                                        value={props.rejectMessage}
                                        onChange={props.onRejectMessageChange}
                                    />
                                </FormGroup>

                                {props.instructions && (
                                    <div
                                        id="instructions"
                                        dangerouslySetInnerHTML={{
                                            __html: props.instructions
                                        }}
                                    ></div>
                                )}

                                {!props.working && (
                                    <ButtonGroup>
                                        <Button onClick={props.closeModal} bsStyle="default">
                                            {Translate('photographer-invoice/modal/create/abort')}
                                        </Button>
                                        <Button
                                            onClick={() => props.reject(props.invoice)}
                                            bsStyle="danger"
                                        >
                                            {Translate('photographer-invoice/modal/create/reject')}
                                        </Button>
                                        <Button
                                            onClick={() => props.update(props.invoice)}
                                            bsStyle="default"
                                        >
                                            {Translate('photographer-invoice/modal/create/update')}
                                        </Button>
                                        <Button onClick={() => window.print()} bsStyle="primary">
                                            {Translate('photographer-invoice/modal/create/print')}
                                        </Button>
                                        <Button onClick={props.save} bsStyle="primary">
                                            {Translate('photographer-invoice/modal/create/save')}
                                        </Button>
                                    </ButtonGroup>
                                )}
                                {props.working && <i className="load-spin-dark"></i>}
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
            )}

            {!props.allowSaving && props.allowRejecting && (
                <Modal show={true} onHide={props.closeModal} bsSize="large">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {Translate('photographer-invoice/modal/create/title')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col xs={12} lg={9}>
                                {props.html && (
                                    <div
                                        id="invoice-preview"
                                        dangerouslySetInnerHTML={{
                                            __html: props.html
                                        }}
                                    ></div>
                                )}
                            </Col>
                            <Col xs={12} lg={3} className="hide-print invoice-modifier-column">
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate(
                                            'photographer-invoice/modal/create/reject-message'
                                        )}
                                    </ControlLabel>
                                    <FormControl
                                        required
                                        componentClass="textarea"
                                        name="rejectMessage"
                                        className="text-area-roomy"
                                        value={props.rejectMessage}
                                        onChange={props.onRejectMessageChange}
                                    />
                                </FormGroup>

                                {props.instructions && (
                                    <div
                                        id="instructions"
                                        dangerouslySetInnerHTML={{
                                            __html: props.instructions
                                        }}
                                    ></div>
                                )}

                                {!props.working && (
                                    <ButtonGroup>
                                        <Button onClick={props.closeModal} bsStyle="default">
                                            {Translate('photographer-invoice/modal/create/abort')}
                                        </Button>
                                        <Button
                                            onClick={() => props.reject(props.invoice)}
                                            bsStyle="danger"
                                        >
                                            {Translate('photographer-invoice/modal/create/reject')}
                                        </Button>
                                        <Button onClick={() => window.print()} bsStyle="primary">
                                            {Translate('photographer-invoice/modal/create/print')}
                                        </Button>
                                    </ButtonGroup>
                                )}
                                {props.working && <i className="load-spin-dark"></i>}
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
            )}

            {!props.allowSaving && !props.allowRejecting && props.showRejectMessage && (
                <Modal show={true} onHide={props.closeModal} bsSize="large">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {Translate('photographer-invoice/modal/create/title')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col xs={12} lg={9}>
                                {props.html && (
                                    <div
                                        id="invoice-preview"
                                        dangerouslySetInnerHTML={{
                                            __html: props.html
                                        }}
                                    ></div>
                                )}
                            </Col>
                            <Col xs={12} lg={3} className="hide-print invoice-modifier-column">
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate(
                                            'photographer-invoice/modal/create/reject-message'
                                        )}
                                    </ControlLabel>
                                    <FormControl
                                        readOnly
                                        componentClass="textarea"
                                        name="rejectMessage"
                                        className="text-area-roomy"
                                        value={props.rejectMessage}
                                    />
                                </FormGroup>

                                {props.instructions && (
                                    <div
                                        id="instructions"
                                        dangerouslySetInnerHTML={{
                                            __html: props.instructions
                                        }}
                                    ></div>
                                )}
                                {!props.working && (
                                    <ButtonGroup>
                                        <Button onClick={props.closeModal} bsStyle="default">
                                            {Translate('photographer-invoice/modal/create/abort')}
                                        </Button>
                                        <Button onClick={() => window.print()} bsStyle="primary">
                                            {Translate('photographer-invoice/modal/create/print')}
                                        </Button>
                                    </ButtonGroup>
                                )}
                                {props.working && <i className="load-spin-dark"></i>}
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
            )}

            {props.allowSaving && !props.allowRejecting && props.showRejectMessage && (
                <Modal show={true} onHide={props.closeModal} bsSize="large">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {Translate('photographer-invoice/modal/rejection/title')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="invoice-modal-row">
                            <Col xs={12} lg={7} className="invoice-preview-column">
                                {props.html && (
                                    <div
                                        id="invoice-preview"
                                        dangerouslySetInnerHTML={{
                                            __html: props.html
                                        }}
                                    ></div>
                                )}
                            </Col>
                            <Col xs={12} lg={5} className="hide-print invoice-modifier-column">
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate(
                                            'photographer-invoice/modal/rejection/reject-message'
                                        )}
                                    </ControlLabel>
                                    <FormControl
                                        readOnly
                                        componentClass="textarea"
                                        name="rejectMessage"
                                        className="text-area-roomy"
                                        value={props.rejectMessage}
                                    />
                                </FormGroup>
                                {!props.working && (
                                    <ButtonGroup>
                                        <Button onClick={props.closeModal} bsStyle="default">
                                            {Translate(
                                                'photographer-invoice/modal/rejection/button-label/abort'
                                            )}
                                        </Button>
                                        <Button
                                            onClick={() => props.update(props.invoice)}
                                            bsStyle="default"
                                        >
                                            {Translate(
                                                'photographer-invoice/modal/rejection/button-label/update'
                                            )}
                                        </Button>
                                        <Button onClick={() => window.print()} bsStyle="primary">
                                            {Translate(
                                                'photographer-invoice/modal/rejection/button-label/print'
                                            )}
                                        </Button>
                                        <Button onClick={props.save} bsStyle="primary">
                                            {Translate(
                                                'photographer-invoice/modal/rejection/button-label/unlock'
                                            )}
                                        </Button>
                                    </ButtonGroup>
                                )}
                                {props.working && <i className="load-spin-dark"></i>}
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
            )}
        </div>
    );
};

export default ViewPhotographerInvoiceModal;
